<template>
  <div>
    <el-row>
      <el-col :offset="1" :span="23">
        <div style="font-size:20px;margin-bottom:20px">Ticket Events (first 100)</div>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :offset="1" :span="4">
        <el-input
          placeholder="Search text (blank separated)"
          size="small"
          prefix-icon="el-icon-search"
          v-model="filters.searchText"
        />
      </el-col>
      <el-col :span="2">
        <el-input
          placeholder="Start MMDD"
          size="small"
          prefix-icon="el-icon-search"
          v-model="filters.startDate"
        />
      </el-col>
      <el-col :span="2">
        <el-input
          placeholder="End MMDD"
          size="small"
          prefix-icon="el-icon-search"
          v-model="filters.endDate"
        />
      </el-col>
      <el-col :span="1">
        <div
          @click="refreshData()"
          v-shortkey="['enter']"
          @shortkey="refreshData()"
          style="cursor:pointer;"
        >
          <i class="el-icon-refresh" style="color:#409EFF;font-size:24px" />
        </div>
      </el-col>
      <el-col :span="1">
        <div @click="downloadData()" style="cursor:pointer;">
          <i class="el-icon-download" style="color:#409EFF;font-size:24px" />
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :offset="1" :span="22">
        <el-divider content-position="left"></el-divider>
      </el-col>
    </el-row>
    <el-row>
      <el-col :offset="1" :span="22">
        <el-table :data="events" empty-text="Fill search criteria" border stripe>
          <el-table-column label="Moment" width="200px">
            <template slot-scope="scope">{{dateTime(scope.row.moment)}}</template>
          </el-table-column>
          <el-table-column label="Barcode" width="200px">
            <template slot-scope="scope">
              <!--router-link
                :to="{ path: 'tickets', query: { barcode:  scope.row.barcode}}"
              >{{scope.row.barcode}}</router-link-->
              <div
                @click="refreshDataByBarcode(scope.row.barcode)"
                style="cursor:pointer;"
              >{{scope.row.barcode}}</div>
            </template>
          </el-table-column>
          <el-table-column label="Device" width="100px">
            <template slot-scope="scope">
              <router-link
                :to="{ name: 'Device', params: { id:  scope.row.deviceCode}}"
              >{{scope.row.deviceHumanReadableCode}}</router-link>
            </template>
          </el-table-column>
          <el-table-column label="Type" width="350px">
            <template slot-scope="scope">
              <el-tooltip placement="bottom-start" effect="light">
                <div slot="content">{{scope.row.description}}</div>
                <div>{{scope.row.type}}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="description" label="Description" width="500px"/> -->
          <el-table-column prop="extraInfo" label="Extra" />
          <el-table-column label="Details" width="100px">
            <template slot-scope="scope">
              <el-popover placement="left" width="600" trigger="click">
                <div style="height: 800px;">
                  <div v-html="getTicketSnapshot(scope.row)" style="height: 100%; overflow-y:auto;"></div>
                </div>
                <el-button slot="reference" size="mini">Details</el-button>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>


<script>
import axios from "axios";

export default {
  name: "Tickets",
  // props: ["barcode"],
  data() {
    return {
      events: [],
      filters: {
        searchText: null,
        startDate: null,
        endDate: null
      }
    };
  },
  mounted() {
    //console.log("mounted");
  },
  // beforeRouteUpdate(to, from, next) {
  //   // react to route changes...
  //   console.log("beforeRouteUpdate");
  //   console.log(to.query.barcode);
  //   if (to.query.barcode) {
  //     this.filters.searchText = to.query.barcode;
  //     this.refreshData();
  //   }
  //   next();
  // },
  methods: {
    dateTime(moment) {
      var date = new Date(moment);
      var ret = `${date.getFullYear()}-${this.formatNumber2Digits(
        date.getMonth() + 1
      )}-${this.formatNumber2Digits(date.getDate())} ${this.formatNumber2Digits(
        date.getHours()
      )}:${this.formatNumber2Digits(
        date.getMinutes()
      )}:${this.formatNumber2Digits(date.getSeconds())}`;
      return ret;
    },
    formatNumber2Digits(num) {
      return ("00" + num).slice(-2);
    },
    formatJSON(json) {
      var tmp = json;
      var ident = 1;
      var perIdent = "......";
      var ret = "";
      var ii = 0;
      var applyIdent = function() {
        for (var ii = 0; ii < ident; ii++) {
          ret += perIdent;
        }
      };
      for (var i = 0; i < tmp.length; i++) {
        var c = tmp.charAt(i);
        var found = false;
        if (c === ",") {
          ret += "<br>";
          applyIdent();
          found = true;
        }
        if (!found && c === "{") {
          ret += c;
          ret += "<br>";
          ident++;
          applyIdent();
          found = true;
        }
        if (!found && c === "}") {
          ret += "<br>";
          ident--;
          applyIdent();
          ret += c;
          found = true;
        }
        if (!found) {
          ret += c;
        }
      }
      return ret;
    },
    getTicketSnapshot(row) {
      var ret = this.formatJSON(row.ticketSnapshot) + "<br>";
      if (row.parkingSystemTicketSnapshot) {
        ret +=
          "Amano=" + this.formatJSON(row.parkingSystemTicketSnapshot) + "<br>";
      }
      return ret;

      // var tmp = row.ticketSnapshot;
      // var ident = 1;
      // var perIdent='......';
      // var ret = "";
      // var ii = 0;
      // var applyIdent=function (){
      //     for (var ii = 0; ii < ident; ii++) {
      //       ret += perIdent;
      //     }
      // };
      // for (var i = 0; i < tmp.length; i++) {
      //   var c = tmp.charAt(i);
      //   var found = false;
      //   if (c === ",") {
      //     ret += "<br>";
      //     applyIdent();
      //     found = true;
      //   }
      //   if (!found && c === "{") {
      //     ret += c;
      //     ret += "<br>";
      //     ident++;
      //     applyIdent();
      //     found = true;
      //   }
      //   if (!found && c === "}") {
      //     ret += "<br>";
      //     ident--;
      //     applyIdent();
      //     ret += c;
      //     found = true;
      //   }
      //   if (!found) {
      //     ret += c;
      //   }
      // }
      // return ret;
    },
    refreshDataByBarcode(barcode) {
      this.filters.searchText = barcode;
      this.refreshData();
    },
    refreshData() {
      //this.$router.replace("tickets");
      if (!this.filters.searchText) {
        this.events = [];
        return;
      }
      //compute full (YYYYNNDD) dates; if provided startDate>toDayMD => startDate is for previous year
      var toDay = new Date();
      var toDayYear = toDay.getFullYear();
      var toDayMD = (toDay.getMonth() + 1) * 100 + toDay.getDate();
      var startDate = 20010101;
      if (this.filters.startDate) {
        startDate = Number(this.filters.startDate);
        if (toDayMD < startDate) {
          startDate += (toDayYear - 1) * 10000;
        } else {
          startDate += toDayYear * 10000;
        }
      }
      var endDate = 29990101;
      if (this.filters.endDate) {
        endDate = Number(this.filters.endDate) + toDayYear * 10000;
      }
      var url = `${process.env.VUE_APP_API}tickets/events?search=${encodeURIComponent(this.filters.searchText)}&startDate=${startDate}&endDate=${endDate}`;

      axios
        .get(url, {
          headers: {
            Authorization: window.sessionStorage.getItem("token")
          }
        })
        .then(result => {
          this.events = result.data;
        });
    },
    downloadData() {
      //this.$router.replace("tickets");
      var textFilter=this.filters.searchText;
      if (!this.filters.searchText) {
        textFilter='%';
      }
      //compute full (YYYYNNDD) dates; if provided startDate>toDayMD => startDate is for previous year
      var toDay = new Date();
      var toDayYear = toDay.getFullYear();
      var toDayMD = (toDay.getMonth() + 1) * 100 + toDay.getDate();
      var startDate = 20010101;
      if (this.filters.startDate) {
        startDate = Number(this.filters.startDate);
        if (toDayMD < startDate) {
          startDate += (toDayYear - 1) * 10000;
        } else {
          startDate += toDayYear * 10000;
        }
      }
      var endDate = 29990101;
      if (this.filters.endDate) {
        endDate = Number(this.filters.endDate) + toDayYear * 10000;
      }
      var url = `${process.env.VUE_APP_API}tickets/events/csv?search=${encodeURIComponent(textFilter)}&startDate=${startDate}&endDate=${endDate}`;

      axios
        .get(url, {
          headers: {
            Authorization: window.sessionStorage.getItem("token")
          },
          responseType: "blob"
        })
        .then(result => {
          var fileURL = window.URL.createObjectURL(new Blob([result.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "ticket-events.csv");
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);
        });
    }
  }
};
</script>

